import {createSlice} from '@reduxjs/toolkit';
import {loadBuildings} from '../buildings/actions';
import {loadFacilities, loadMap} from './actions';
import {floorsAdapter} from './adapters';
import {FloorsState} from './types';

const initialState = <FloorsState>floorsAdapter.getInitialState({
  mapData: {
    '2d': {},
    '3d': {},
  },
  facilitiesData: {},
});

const slice = createSlice({
  name: 'floors',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadBuildings.fulfilled, (state, action) => {
        floorsAdapter.setAll(state, action.payload.floors ?? {});
      })
      .addCase(loadMap.pending, (state, action) => {
        state.mapData[action.meta.arg.type][action.meta.arg.floorId] = {
          buildingId: action.meta.arg.buildingId,
          type: action.meta.arg.type,
          floorId: action.meta.arg.floorId,
          status: 'Loading',
        };
      })
      .addCase(loadMap.fulfilled, (state, action) => {
        const type = action.payload.type;
        const base = {
          buildingId: action.meta.arg.buildingId,
          floorId: action.meta.arg.floorId,
        };

        if (type === '2d') {
          state.mapData[type][action.meta.arg.floorId] = {
            ...base,
            type,
            status: 'Loaded',
            svg: action.payload.map,
          };
        } else if (type === '3d') {
          state.mapData[type][action.meta.arg.floorId] = {
            ...base,
            type,
            status: 'Loaded',
            featureCollection: action.payload.map,
          };
        }
      })
      .addCase(loadMap.rejected, (state, action) => {
        state.mapData[action.meta.arg.type][action.meta.arg.floorId] = {
          buildingId: action.meta.arg.buildingId,
          floorId: action.meta.arg.floorId,
          status: 'Failed',
          type: action.meta.arg.type,
          errorMessage: action.error.message || 'Failed to load map',
        };
      })
      .addCase(loadFacilities.pending, (state, action) => {
        state.facilitiesData[action.meta.arg.floorId] = {
          buildingId: action.meta.arg.buildingId,
          floorId: action.meta.arg.floorId,
          status: 'Loading',
        };
      })
      .addCase(loadFacilities.fulfilled, (state, action) => {
        state.facilitiesData[action.meta.arg.floorId] = {
          buildingId: action.meta.arg.buildingId,
          floorId: action.meta.arg.floorId,
          status: 'Loaded',
          facilities: action.payload,
        };
      })
      .addCase(loadFacilities.rejected, (state, action) => {
        state.facilitiesData[action.meta.arg.floorId] = {
          buildingId: action.meta.arg.buildingId,
          floorId: action.meta.arg.floorId,
          status: 'Failed',
          errorMessage: action.error.message || 'Failed to load map facilities',
        };
      });
  },
});

export const {reducer: floorsReducer} = slice;
